import { Application } from 'foundations-components/components/Application';
import _get from 'hs-lodash/get';
import { history } from 'in-meeting-experience-ui-components/utils/general';
import { renderRoot } from 'quartz-core/client';

// I18n Configuration
import BasicI18nSetup from 'I18n/init/setup/BasicI18nSetup';
import lang from 'i2l?query=sporks!../lang/en.lyaml';

// Import extra I18n data
import 'I18n/init/data/baseLocales';
import 'I18n/init/data/currency';
import 'I18n/init/data/publicLocales';

// Rhumb
import { RhumbProvider } from 'react-rhumb';
import historyAdapter from 'react-rhumb/historyAdapterV4';
import rhumbConfig from '../rhumb-config.yaml';

// Redux
import { Provider } from 'react-redux';
import { store } from './utils/configureStore';

// Configure the router
import ModalErrorWrapper from 'in-meeting-experience-ui-components/components/common/ModalErrorWrapper';
import { AppContextProvider } from 'in-meeting-experience-ui-components/contexts/app/context';
import { setSessionStorageItem } from 'in-meeting-experience-ui-components/utils/sessionStotage';
import { Router } from 'react-router-dom';
import { Routes } from './components/routes/Routes';
import { INTEGRATION_NAME, MEET_SDK_SESSION_STORAGE_KEY, ORIGIN_SESSION_STORAGE_KEY } from './constants/google-meet';
import { storeStartFailed } from './slices/app/actions';
import { userInfo } from './slices/auth/actions';
import { googleActions } from './slices/google/slice';
import { jsx as _jsx } from "react/jsx-runtime";
export class App {
  // Kicks off the app. This is intentionally not in the constructor.
  start() {
    const storeReady = this.startRedux();
    return storeReady.then(([userInfoResponse]) => {
      const locale = _get(userInfoResponse, 'value.payload.locale', {
        locale: 'en-us',
        langEnabled: false
      });
      return BasicI18nSetup.setup({
        lang,
        user: locale,
        portal: {}
      });
    }).then(() => {
      this.startRouter();
    }).catch(err => {
      store.dispatch(storeStartFailed(err));
    });
  }
  startRedux() {
    this.handleSdkUrlParams();
    return Promise.allSettled([store.dispatch(userInfo())]);
  }
  handleSdkUrlParams() {
    const params = new URLSearchParams(window.location.search);
    const meetSdkParam = params.get('meet_sdk');
    const originParam = params.get('origin');
    if (meetSdkParam && originParam) {
      store.dispatch(googleActions.setSdkParams({
        meet_sdk: meetSdkParam,
        origin: originParam
      }));
      setSessionStorageItem(MEET_SDK_SESSION_STORAGE_KEY, meetSdkParam);
      setSessionStorageItem(ORIGIN_SESSION_STORAGE_KEY, originParam);
      return;
    }
  }
  startRouter() {
    renderRoot( /*#__PURE__*/_jsx(Application, {
      name: "google-meet-add-on-ui",
      children: /*#__PURE__*/_jsx(ModalErrorWrapper, {
        appName: INTEGRATION_NAME,
        children: /*#__PURE__*/_jsx(AppContextProvider, {
          appName: INTEGRATION_NAME,
          children: /*#__PURE__*/_jsx(Provider, {
            store: store,
            children: /*#__PURE__*/_jsx(RhumbProvider, {
              history: historyAdapter(history),
              config: rhumbConfig,
              children: /*#__PURE__*/_jsx(Router, {
                history: history,
                children: /*#__PURE__*/_jsx(Routes, {})
              })
            })
          })
        })
      })
    }));
  }
}